<template>
  <div class="case">
    <div class="case-title">
      <span class="case-title-text">温州市龙湾区天河第一小学——从"无声沸腾"到"探究之火"的科学课堂变革</span>
    </div>
    <div class="case-line"></div>
    <div class="case-main">
      <div class="case-section">
        <p class="case-section__content">
          "过去上《水沸腾了》，学生大多数只能观察到水沸腾的结果，AI数字化设备突破了水沸腾实验'只见结果难观过程'的局限，更加直观、有趣。"温州市龙湾区天河第一小学涂黎娜老师上完公开课后说道。
        </p>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">一、传统科学课堂的"无声沸腾"</h3>
        <p class="case-section__content">
          在过去的龙湾天河一小，科学实验课曾面临"安静的困境"： 现象转瞬即逝，实验中的细微变化仅靠肉眼难以捕捉，学生记录的数据支离破碎；课堂参与冷热不均，小组实验沦为少数学生的主场，多数孩子沦为"旁观者"；探究浅尝辄止，面对"沸腾后温度是否变化"等追问，传统教具无法支撑深度思辨。
        </p>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">二、AI数字化实验室点燃"探究之火"</h3>
        <p class="case-section__content">
          2025年秋季学期，学校以"AI数字化探究实验室"为支点，开启实验教学整体升级。
        </p>
        <ul class="case-section__list">
          <li class="case-section__list-item">
            <strong>真实场景嫁接：</strong>涂黎娜老师以"煮水饺"生活情境切入，将抽象概念转化为可感可知的探索任务；
          </li>
          <li class="case-section__list-item">
            <strong>多维感知升级：</strong>通过细分"温度、气泡、白气"等观察维度，搭载传感器实时生成动态折线图，让科学现象"有图有真相"；
          </li>
          <li class="case-section__list-item">
            <strong>智慧协同共生：</strong>平板一键推送任务、实时同步数据、虚拟数字人引导思辨，构建"人机共教"新生态。
          </li>
        </ul>
        <div class="case-images">
          <div class="case-image-placeholder" >
            <img src="@/assets/images/case/case4_1.jpeg" alt="case4-1">
          </div>
          <div class="case-image-placeholder" >
            <img src="@/assets/images/case/case4_2.jpeg" alt="case4-2">
          </div>
        </div>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">三、从"看见现象"到"触摸真理"的飞跃</h3>
        <p class="case-section__content">
          学校科学老师们也被邀请在温州市龙湾区教师发展中心举办的"AI赋能科学教育"的教研活动中分享他们在科学实验上取得的经验成果。
        </p>
        <p class="case-section__content">
          教师们分享，通过平板掌握学生观察科学现象变化的完整轨迹，破解教学难点，实现从"经验驱动"到"数据驱动"的精准指导。AI系统自动记录实验过程中数据输入，原本零散的单点发现被整合成完整的认知图谱，解决了"数据支离破碎"的困境，让每个学生都能基于自己的发现参与分析，打破了"少数学生主导"的局面。观察实验现象过程中，学生深入探究沸腾过程中物质状态的微观变化，实现了从"看见现象"到"理解本质"的认知跃升，在与虚拟数字人的对话中梳理思路，完成从"被动接受"到"主动建构"的关键转变。
        </p>
        <div class="case-images">
          <div class="case-image-placeholder" >
            <img src="@/assets/images/case/case4_3.jpeg" alt="case4-3">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Case4"
}
</script>
<style lang="scss" scoped>
.case {
  width: 1185px;
  margin: 0 auto;
  background: #FFFFFF;
  padding: 32px;
  
  &-title {
    font-size: 24px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #262626;
  }
  
  &-line {
    width: 1120px;
    height: 1px;
    margin: 32px auto;
    background: #E5E5E5;
  }
  
  &-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  &-images {
    display: flex;
    gap: 20px;
    margin: 16px 0;
    align-items: stretch;
  }
  
  &-image-placeholder {
    flex: 0 0 auto;
    height: 300px;
    min-width: 0;
    background: #F5F5F5;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  &-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    &__title {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: #262626;
      margin: 0;
    }
    
    &__content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: #262626;
    }

    &__list {
      margin: 0;
      padding-left: 24px;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    &__list-item {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: #262626;
      position: relative;
      padding-left: 8px;

      &::before {
        content: "•";
        position: absolute;
        left: -16px;
        color: #3188F6;
        font-weight: bold;
        font-size: 20px;
      }

      strong {
        color: #262626;
        font-weight: 600;
      }
    }
  }
}
</style>

